export enum Status {
  No = 0,
  Yes = 1,
  Pending = -1
}

export enum UserType {
  Normal = 0,
  VIP = 1
}

export enum FileType {
  Image = 0,
  PDF
}